import Component from './CommunityGrantDoorAccessDialogContainer'

export default Component
